import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useLeaderboardStore from './state-hook';
import {
  MainText, RankNumber, SecondaryText,
} from './styles';

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & > .header {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    > .main {
      display: flex;
      align-items: center;
      > span {
        ${MainText};
        color: ${props => props.theme.bodyColor};
      }
    }

    > .secondary {
      display: flex;
      align-items: center;
      > span {
        ${SecondaryText};
        margin-left: 4px;
      }

      > span.primary {
        color: ${props => props.theme.primaryColor};
      }
    }
  }

  & > .row {
    ${RankNumber};
    color: ${props => props.theme.bodyColor};
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;

const rank = d => (Number.isFinite(d) ? d : '-');

export default function Current({ contributorCount }) {
  const current = useLeaderboardStore(state => state.current);

  return (
    <Column>
      <div className="header">
        <div className="main">
          <span>livewire rank</span>
        </div>
        <div className="secondary">
          <span className="primary">{contributorCount}</span>
          <span className="plain">total contributors</span>
        </div>
      </div>
      {current.map(d => <span className="row" key={d.id}>{rank(d.rank)}</span>)}
    </Column>
  );
}

Current.propTypes = { contributorCount: PropTypes.number.isRequired };
